
import { Card } from "@/components/ui/card";
import { BookingFormData } from "../../ParcelBookingForm";
import { transformFormDataToBookingDetails } from "./utils";
import BookingContactCard from "../../bookings/booking-details/BookingContactCard";
import BookingParcelOverviewCard from "../../bookings/booking-details/BookingParcelOverviewCard";
import BookingParcelCard from "../../bookings/booking-details/BookingParcelCard";
import BookingDateCard from "../../bookings/booking-details/BookingDateCard";
import { Separator } from "@/components/ui/separator";

interface BookingFormSummaryProps {
  formData: BookingFormData;
}

const BookingFormSummary = ({ formData }: BookingFormSummaryProps) => {
  const transformedBooking = transformFormDataToBookingDetails(formData);

  return (
    <Card className="p-6 space-y-6 bg-card border-border">
      {/* Overview Section */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-card-foreground">Overview</h3>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="lg:col-span-1">
            <BookingDateCard date={transformedBooking.collection_datetime} />
          </div>
          <div className="lg:col-span-2">
            <BookingParcelOverviewCard 
              parcels={transformedBooking.parcels} 
              totalParcelsCount={transformedBooking.total_parcels_count} 
            />
          </div>
        </div>
      </div>

      <Separator className="bg-border" />

      {/* Address & Contacts Section */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-card-foreground">Address & Contacts</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <BookingContactCard 
            type="Collection" 
            contacts={transformedBooking.collection_contacts} 
            address={transformedBooking.collection_address} 
          />
          <BookingContactCard 
            type="Delivery" 
            contacts={transformedBooking.delivery_contacts} 
            address={transformedBooking.delivery_address} 
          />
        </div>
      </div>

      {/* Parcel Details Section */}
      {transformedBooking.parcels.length > 0 && (
        <>
          <Separator className="bg-border" />
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-card-foreground">Parcel Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {transformedBooking.parcels.map((parcel, index) => (
                <BookingParcelCard 
                  key={parcel.id} 
                  parcel={parcel} 
                  index={index} 
                />
              ))}
            </div>
          </div>
        </>
      )}

      {/* Additional Instructions */}
      {formData.instructions && (
        <>
          <Separator className="bg-border" />
          <div>
            <h3 className="text-lg font-semibold text-card-foreground mb-2">Additional Instructions</h3>
            <p className="text-card-foreground">{formData.instructions}</p>
          </div>
        </>
      )}
    </Card>
  );
};

export default BookingFormSummary;
